module.exports = __webpack_public_path__ + "static/media/dashboard-image.4e70364b.png";